import { render } from "./Quotes.vue?vue&type=template&id=bedffce0"
import script from "./Quotes.vue?vue&type=script&lang=js"
export * from "./Quotes.vue?vue&type=script&lang=js"
script.render = render

export default script